export default __webpack_public_path__ + "static/media/5_2_hl.d1dd9a3b.png";